import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import BeforeAfterSlider from './BeforeAfterSlider';
import Reveal from './Reveal';
import SHOWCASE from '../data/showcase.json';

/**
 * „Naše práce" hned pod hero – 2–3 posuvníky před/po ze skutečných zakázek.
 *
 * Data i fotky připraví build (scripts/fetch-content.js): vybere zakázky podle
 * zadání (túje/živý plot, zarostlý pozemek, přerostlá tráva) a fotky uloží do
 * public/realizace jako WebP v šířkách 480/768/1200. Import JSONu je
 * synchronní, takže sekce je v HTML hned – bez načítání a posunu layoutu.
 *
 * Když build žádné fotky nezíská, sekce se nezobrazí. Vymyšlené nebo stock
 * fotky tu nikdy nebudou – zákazník by poznal, že nejsou naše.
 */
const srcSet = (variants) => Object.entries(variants)
  .map(([w, url]) => `${url} ${w}w`)
  .join(', ');

const SIZES = '(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw';

const RealizaceShowcase = () => {
  if (!Array.isArray(SHOWCASE) || SHOWCASE.length === 0) return null;

  return (
    <section className="py-12 md:py-16 bg-white" data-testid="showcase-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-[#111827]" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Naše práce
          </h2>
          <p className="text-[#4B5563] mt-2">Posuňte čárou a porovnejte, jak to vypadalo před a po.</p>
        </Reveal>

        <div className={`grid gap-6 ${SHOWCASE.length >= 3 ? 'sm:grid-cols-2 lg:grid-cols-3' : 'sm:grid-cols-2'}`}>
          {SHOWCASE.map((item, idx) => (
            <figure key={item.slug} className="rounded-2xl overflow-hidden border border-gray-100 shadow-sm bg-white">
              <BeforeAfterSlider
                before={item.before[768]}
                after={item.after[768]}
                beforeSrcSet={srcSet(item.before)}
                afterSrcSet={srcSet(item.after)}
                sizes={SIZES}
                width={1200}
                height={900}
                alt={item.alt}
                // První fotka se načte hned, ostatní až při scrollu (audit bod 6)
                eager={idx === 0}
                className="aspect-[4/3]"
              />
              <figcaption className="px-4 py-3">
                <Link
                  to={`/nase-prace/${item.slug}`}
                  className="font-semibold text-[#111827] hover:text-[#2E8B3E] transition-colors"
                >
                  {item.title}
                </Link>
                {item.location && <p className="text-sm text-gray-500">{item.location}</p>}
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/nase-prace"
            className="inline-flex items-center gap-2 rounded-full border-2 border-[#2E8B3E] text-[#2E8B3E] hover:bg-[#F0FDF4] font-semibold px-6 h-11 transition-colors"
            data-testid="showcase-more"
          >
            Další realizace
            <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RealizaceShowcase;
